<template>
  <div id="root">
    <div style="outline:none" tabindex="-1" role="group">
      <div class="main-container">
        <div class="app-container">
          <div class="main-page-container">
            <div style="outline:none" tabindex="-1" role="group">
              <div class="page-container article-type">
                <Header />
                <div class="page-wrapper bg-layer">
                  <div class="view mov"  v-html="view" :class="{ active: show }"></div>
                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
export default {
  name: "locator",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      view: '',
      show: false
    }
  },
  mounted() {
    this.getDataList();
    this.show = true;
  },
  methods: {
    async getDataList() {
      let { data } = await axios.get(`${this.$api}/Api/CustomItem?name=${this.$route.params.id}&type=EditText`);
      this.view = data.data;
    }
  }
};
</script>

<style scoped>
.view{
  margin: 100px auto 50px; max-width:1000px;font-size: 16px
}
@media (max-width:769px) {
  .view{
    padding: 0 20px;
  }
}
.mov.active {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}
.mov {
  opacity: 0;
  transform: translate(0%, 100%) matrix(1, 0, 0, 1, 0, 0);
  transition: all 1s;
}
</style>